import axios from 'axios';
import axiosRetry from 'axios-retry';

class ApiService {
    constructor() {
        let service = axios.create({
            baseURL: window.websiteSettings.baseApiUrl,
            //baseURL: "http://localhost:51438",
            //baseURL: "http://frank-staging.chauffeurbookingsoftware.com",
            //baseURL: "https://account.chauffeurbookingsoftware.com",
            //baseURL: "http://test-account.chauffeurbookingsoftware.com",
            //baseURL: window.webconfig.apiUrl,
            headers: { csrf: "token" }
        });
        axiosRetry(service,
        {
            retries: 4,
            retryDelay: (retryCount) => {
                return retryCount * 1000;
            }
        });

        service.interceptors.response.use(this.handleSuccess, this.handleError);

        this.service = service;
    }

    handleSuccess(response) {
        return response;
    }

    handleError(error) {
        //TODO: remove this when we implement unitary erject failures
        return Promise.reject(error);

        switch (error.response.status) {
        case 401:
            this.redirectTo(document, '/');
            break;
        case 404:
            this.redirectTo(document, '/404');
            break;
        default:
            this.redirectTo(document, '/500');
            break;
        }
        return Promise.reject(error);
    }

    redirectTo (document, path) {
        document.location = path;
    }
    
    get(path, callback) {
        return this.service.get(path).then(
            (response) => callback(response.status, response.data)
        );
    }

    patch(path, payload, callback) {
        return this.service.request({
            method: 'PATCH',
            url: path,
            responseType: 'json',
            data: payload
        }).then((response) => callback(response.status, response.data));
    }

    post(path, payload, callback) {
        return this.service.request({
            method: 'POST',
            url: path,
            responseType: 'json',
            data: payload
        }).then((response) => callback(response.status, response.data));
    }

    // METHODS

    getWebsiteSettings(apiKey) {
        return this.service.get("websitesApi/GetWebsiteSettings/" + apiKey);
    }

    /**
     *
     * @param {any} bookingInfo
     */
    createBooking(bookingInfo) {
        return this.service.post("bookingApi/createBooking", bookingInfo);
    }

    /**
     * 
     * @param {any} bookingInfo
    */
    getTripPrice(bookingInfo) {
        /*public int WebsiteId { get; set; }
        public string PickupDateTime { get; set; }
        public BookingType Type { get; set; }
        public decimal DurationInHours { get; set; }
        public LocationInfo From { get; set; }
        public LocationInfo To { get; set; }
        public int? CarTypeId { get; set; }
        public int? ClientId { get; set; }*/
        console.log("calling service", bookingInfo);

        return this.service.get("bookingApi/getTripPrices",
        {
            params: {
                bookingInfo: bookingInfo
            }
        });
    }

    checkStripeSourceStatus(sourceId, websiteId) {
        return this.service.get("bookingApi/checkStripeSourceStatus/" + sourceId + "/" + websiteId);
    }

     /**
     * 
     * @param {any} bookingInfo
     */
    getTripPriceForAllCar(bookingInfo) {
        /*public int WebsiteId { get; set; }
        public string PickupDateTime { get; set; }
        public BookingType Type { get; set; }
        public decimal DurationInHours { get; set; }
        public LocationInfo From { get; set; }
        public LocationInfo To { get; set; }
        public int? CarTypeId { get; set; }
        public int? ClientId { get; set; }*/
        console.log("calling service", bookingInfo);

        return this.service.get("bookingApi/getBookingPriceForAllCars",
        {
            params: {
                bookingInfo: bookingInfo
            }
        });
    }

    /**
     * 
     * @param {string} bguid
     * @param {string} stripeSourceId
     */
    chargeBookingWithStripe(bguid, stripeSourceId) {
        return this.service.post("bookingApi/chargeBookingWithStripe", { bookingGuid: bguid, stripeSourceId: stripeSourceId });
    }

    /**
     * 
     * @param {string} guid
     */
    getBookingInfo(guid) {
        return this.service.get("bookingApi/getBookingInfo/" + guid);
    }

    /**
    * 
    * @param {string} apiKey
    */
    getAvailableCarTypes(apiKey) {
        return this.service.get("bookingApi/getWebsiteCarTypes/" + apiKey);
    }

    /**
     * 
     * @param {Object} contactForm
     * @param {string} contactForm.apiKey - api key 
     * @param {string} contactForm.name - customer name 
     * @param {string} contactForm.firstName - customer first name 
     * @param {string} contactForm.lastName - customer last name 
     * @param {string} contactForm.phone - customer phone
     * @param {string} contactForm.email - customer email
     * @param {string} contactForm.message - customer message
     */
    sendContactForm(contactForm) {
        //console.log(contactForm);
        return this.service.post("supportApi/sendContactForm", contactForm);
    }

    /**
     * 
     * @param {Object} quotationForm
     * @param {string} quotationForm.name - customer name
     * @param {string} quotationForm.phone - customer phone
     * @param {string} quotationForm.email - customer email
     * @param {string} quotationForm.message - customer message
     * @param {string} quotationForm.from - from location
     * @param {string} quotationForm.to - to location
     * @param {string} quotationForm.hours - number of hours
     * @param {string} quotationForm.pickupAt - pickup at
     */
    sendQuotationForm(quotationForm) {
        return this.service.post("supportApi/sendNotAllowedQuotationForm", quotationForm);
    }
}

export default new ApiService();